type GoogleMapsLocale = {
  language: string;
  region: string;
};

type GoogleMapsWindow = Window & {
  google?: unknown;
  __googleMapsCallback__?: () => void;
  gm_authFailure?: () => void;
};

const GOOGLE_MAPS_LOCALE_BY_APP_LANGUAGE: Record<string, GoogleMapsLocale> = {
  "pt-BR": { language: "pt-BR", region: "BR" },
  "en-US": { language: "en", region: "US" },
  "es-ES": { language: "es", region: "ES" },
  "zh-CN": { language: "zh-CN", region: "CN" },
};

const DEFAULT_GOOGLE_MAPS_LOCALE = GOOGLE_MAPS_LOCALE_BY_APP_LANGUAGE["pt-BR"];

export const resolveGoogleMapsLocale = (appLanguageCode: string): GoogleMapsLocale =>
  GOOGLE_MAPS_LOCALE_BY_APP_LANGUAGE[appLanguageCode] ?? DEFAULT_GOOGLE_MAPS_LOCALE;

export const buildGoogleMapsLocaleKey = (locale: GoogleMapsLocale): string =>
  `${locale.language}-${locale.region}`;

/**
 * Limpa script/globals do Google Maps JS API para permitir nova carga com outro locale.
 * Chamar **somente** com o mapa já desmontado (evita crash de instâncias ativas).
 */
export const resetGoogleMapsJavascriptApi = (): void => {
  if (typeof document === "undefined" || typeof window === "undefined") {
    return;
  }

  document
    .querySelectorAll('script[src*="maps.googleapis.com/maps/api/js"]')
    .forEach((node) => node.remove());

  const win = window as GoogleMapsWindow;
  delete win.__googleMapsCallback__;
  delete win.gm_authFailure;
  delete win.google;
};
